/***
	externalLink Plugin:
	--------------------
	This plugin applies a short delay to all external links, that is opened in the same window.
	The delay is introduced to enable GA tracking on the links, via the triggered event.
***/

(function($, window) {
	"use strict";

	var $d = $(window.document);
	$.fn.externalLink = function() {
		// Apply as a 'live' event so that future links are affected as well + it enables propagation
		// stop for links where this behaviour is not wanted even if they are within range of the selector
		$d.on("click", this.selector, function(e) {
			var url = this.href,
				
				// Prefetch conditions, for improved readability
				isSameDomain = this.hostname.toLowerCase() === window.location.hostname.toLowerCase(),
				isJS = url.match("(mailto|javascript)[:]") !== null,
				metaKeyPressed = !(e.metaKey || e.ctrlKey || e.shiftKey),
				newWin = this.target === "_blank" || metaKeyPressed,
				
				// Predefined variable (for optimization of the script)
				$e;

			// If the link is to same domain (or a JS call), then just break method here,
			// as this is just for external links
			if(isSameDomain || isJS || e.isDefaultPrevented())
			{ return true; }

			/***** Is external link *****/

			// Trigger the event to bind handlers to
			$e = $.Event("externallink.click");
			$d.trigger($e, [this]);

			// Break the method here, if the link opens in a new window (or event is stopped), as the
			// tracking should still be available, but no delay is nessesary since the page is not redirected.
			if( newWin || $e.isDefaultPrevented() )
			{  return true;}

			/***** Is not opened in new window *****/

			// Prevent default behaviour (page redirect), so we kan delay it long enough for
			// an action to be taken on the event
			e.preventDefault();

			// Redirect to the desired URL after a short delay
			window.setTimeout(function() { window.location.assign(url); }, 100);
		});

		return this;
	};
})(jQuery, window);